import styles from "./ErrorMessage.module.css";

export const ErrorMessage = ({ children }) => (
  <div className={styles.container}>
    <div className={styles.content}>{children}</div>
  </div>
);
